import "@corpuscomplete/web-ui/globals.css";
import "temporal-polyfill/global";

import { Env } from "./env";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import * as Sentry from "@sentry/react";
import { tanstackRouterBrowserTracingIntegration } from "@sentry/react";

if (Env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: Env.VITE_SENTRY_DSN,
    release: Env.VITE_GIT_COMMIT_SHA,

    integrations: [
      tanstackRouterBrowserTracingIntegration(router),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],

    tracesSampleRate: Number(Env.VITE_SENTRY_TRACES_SAMPLE_RATE),
    replaysSessionSampleRate: Number(Env.VITE_SENTRY_REPLAYS_SAMPLE_RATE),
    replaysOnErrorSampleRate: 1.0,

    tracePropagationTargets: [Env.VITE_API_URL, Env.VITE_ZERO_CACHE_URL].filter(Boolean),

    beforeBreadcrumb(breadcrumb) {
      if (breadcrumb.category === "console") {
        if (breadcrumb.level !== "error" && breadcrumb.level !== "warning") {
          return null;
        }
      }
      return breadcrumb;
    },

    ignoreErrors: [
      "ResizeObserver loop",
      "ResizeObserver loop completed with undelivered notifications",
      /Network request failed/,
      /Load failed/,
      /fetch failed/,
    ],

    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^moz-extension:\/\//i],
  });
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

if (!rootElement.innerHTML) {
  const root = createRoot(rootElement);
  root.render(<RouterProvider router={router} />);
}
